"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "POPULAR", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.POPULAR;
  }
});
Object.defineProperty(exports, "NEW", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.NEW;
  }
});
Object.defineProperty(exports, "FOR_STARTUPS", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.FOR_STARTUPS;
  }
});
Object.defineProperty(exports, "FOR_AGENCIES", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.FOR_AGENCIES;
  }
});
Object.defineProperty(exports, "HOMEMADE", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.HOMEMADE;
  }
});
Object.defineProperty(exports, "PIESYNC", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.PIESYNC;
  }
});
Object.defineProperty(exports, "CMS", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.CMS;
  }
});
Object.defineProperty(exports, "ABM", {
  enumerable: true,
  get: function get() {
    return _CollectionSlug.ABM;
  }
});
exports.FOR_CUSTOMER_SUCCESS_TEAMS = exports.FOR_SALES_TEAMS = exports.FOR_MARKETING_TEAMS = exports.FREE = void 0;

var _CollectionSlug = require("ecosystem-marketplace-core/constants/urlSlugs/CollectionSlug");

var FREE = 'free';
exports.FREE = FREE;
var FOR_MARKETING_TEAMS = 'marketing-teams';
exports.FOR_MARKETING_TEAMS = FOR_MARKETING_TEAMS;
var FOR_SALES_TEAMS = 'sales-teams';
exports.FOR_SALES_TEAMS = FOR_SALES_TEAMS;
var FOR_CUSTOMER_SUCCESS_TEAMS = 'customer-success-teams';
exports.FOR_CUSTOMER_SUCCESS_TEAMS = FOR_CUSTOMER_SUCCESS_TEAMS;


//////////////////
// WEBPACK FOOTER
// ./js/constants/StorefrontCollectionSlug.js
// module id = 218
// module chunks = 209 210 211 212 213